import { render, staticRenderFns } from "./alarm-mode.vue?vue&type=template&id=1c1cda0e&scoped=true&"
import script from "./alarm-mode.vue?vue&type=script&lang=ts&"
export * from "./alarm-mode.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-mode.vue?vue&type=style&index=0&id=1c1cda0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1cda0e",
  null
  
)

export default component.exports